import { UploadTask } from '@aws-amplify/storage';
import { Amplify, Storage } from 'aws-amplify';
import { MutableRefObject } from 'react';

import { generateGuid } from './guid';
import { safelyJoinPaths } from './paths';

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
      ...(process.env.REACT_APP_COGNITO_ENDPOINT && {
        endpoint: process.env.REACT_APP_COGNITO_ENDPOINT,
      }),
      redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_URL,
      redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_URL,
      oauth: {
        domain: process.env.REACT_APP_OAUTH_DOMAIN,
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: process.env.REACT_APP_OAUTH_REDIRECT_URL,
        redirectSignOut: process.env.REACT_APP_OAUTH_REDIRECT_URL,
        responseType: 'code',
      },
    },
    Storage: {
      bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      region: process.env.REACT_APP_COGNITO_REGION,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    },
    cookieStorage: {
      domain: process.env.REACT_APP_AUTH_COOKIE_DOMAIN,
      secure: true,
      path: '/',
      expires: 30,
    },
  });
}

export async function uploadFile(file: File, uploadOperationRef?: MutableRefObject<any>): Promise<string> {
  const fileName = generateGuid();
  try {
    const existingFile = await Storage.get(fileName, { download: true });
    if (existingFile) {
      // File already exist so trigger a new name
      return uploadFile(file);
    }
  } catch {
    // File doesn't exist
    const uploadOperation = Storage.put(fileName, file, {
      acl: 'public-read',
      contentType: file.type,
    });

    if (uploadOperationRef) {
      uploadOperationRef.current = uploadOperation;
    }

    const result = await uploadOperation;
    return getUploadPath(result.key);
  }
  return '';
}

export async function cancelStorage<OperationType extends UploadTask>(operation: OperationType): Promise<boolean> {
  return await Storage.cancel(operation, 'my message for cancellation');
}

const getUploadPath = (key: string): string => {
  return safelyJoinPaths(process.env.REACT_APP_S3_URI, key);
};
